exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\ntable[data-v-5b5eb55d] {\n  width: 50%;\n  margin: auto;\n}\n.evenRow[data-v-5b5eb55d] {\n  background-color: #ffffaa\n}\n#userPartnerList[data-v-5b5eb55d] {\n  border-style: solid;\n}\n#userPartnerList tbody>tr[data-v-5b5eb55d]:hover {\n  background-color: #ffcccc\n}\n.userPage[data-v-5b5eb55d] {\n  margin-bottom: 5%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-5b5eb55d","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ManagementPage/UserPage.vue
// module id = 522
// module chunks = 0